import classnames from "classnames";
import React, { FC, MouseEvent, useId } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Input } from "@components/General/Form/input.component";
import { Label } from "@components/General/Form/label.component";

import "./compare.scss";

interface CompareProps {
    sku: string;
    productComparisonSkuList: string[];
    onSetProductComparisonSkuList: (skuList: string[]) => void;
    className?: string;
}

const Compare: FC<CompareProps> = ({
    sku,
    productComparisonSkuList = [],
    onSetProductComparisonSkuList,
    className,
}: CompareProps) => {
    const { t } = useGranite();
    const shouldPreventSelection =
        productComparisonSkuList.length === 6 &&
        !productComparisonSkuList.includes(sku);
    const id = useId();

    const handleOnClick = (event: MouseEvent) => {
        event.stopPropagation();
    };

    return (
        <div
            className={classnames(className, "compare-product")}
            onClick={handleOnClick}
        >
            <Label for={id} className={"m-0"}>
                <Input
                    id={id}
                    type="checkbox"
                    disabled={shouldPreventSelection}
                    checked={productComparisonSkuList.includes(sku)}
                    onChange={event => {
                        if ((event.target as HTMLInputElement).checked) {
                            return onSetProductComparisonSkuList([
                                ...productComparisonSkuList,
                                sku,
                            ]);
                        }

                        return onSetProductComparisonSkuList(
                            productComparisonSkuList.filter(
                                pcSku => pcSku !== sku,
                            ),
                        );
                    }}
                />
                <span
                    className={classnames("user-select-none", {
                        "text-muted": shouldPreventSelection,
                    })}
                >
                    {t(
                        shouldPreventSelection
                            ? "productComparison.maxAmountSelected"
                            : "productComparison.compareProduct",
                    )}
                </span>
            </Label>
        </div>
    );
};

export default Compare;
